import { useAppSelector } from "./store";

export const useAuth = () => useAppSelector((state) => state.auth);

export const useSidebar = () => useAppSelector((state) => state.sidebar);
